export const constant = {
  max_character_count: 1000,
  aspect_ratio_logo: 1 / 1,
  aspect_ratio_facebook: 1.91 / 1,
  max_img_width: 2900,
  max_img_height: 1400,
};
